export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11935.3a9387ce.jpg";